import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Paths } from "../../../constants/UrlConstants";
import Article from "../../../components/shared/Article";
import { connect } from "react-redux";
import Contentify from "../../../content/Contentify";
import Store from "../../../content/Store";
import ShadowedContainer from "../../shared/containers/ShadowedContainer";
import SummaryDetail from "../../shared/groups/SummaryDetail";
import SummaryDetailRow from "../../shared/groups/SummaryDetailRow";
import styles from "../../../assets/css/modules/claims/payment-details.css";
import DetailContainer from "./../../shared/containers/DetailContainer";
import HowToPayShortfallSection from "./HowToPayShortfallSection";
import ShortfallSummary from "./ShortfallSummary";
import { sentenceToTitleCase } from "../../../helpers/SentenceToTitleCase";
import HelpSection from "../../shared/HelpSection";
import InvoiceBreakdown from "./InvoiceBreakdown";
import WhatYouHaveUsedSection from "./WhatYouHaveUsedSection";
import formatCurrencyAmount from "./../../../helpers/FormatCurrencyAmount";

export const mapStateToPaymentDetails = (state) => {
  let distinctTreatmentDescriptions = [
    ...new Set(
      state.claimsReducer.selectedPolicy.selectedInvoice &&
        state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails.Treatments.map(
          (item) => item.Description
        )
    )
  ];

  return {
    distinctTreatmentDescriptions,
    isNotCashBenefitWithShortfall:
      state.claimsReducer.selectedPolicy.selectedInvoice &&
      state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails &&
      !state.claimsReducer.selectedPolicy.selectedInvoice.PaymentDetails
        .IsCashBenefitAndHasShortfall,
    navigatedFromNotification:
      state.claimsReducer.selectedPolicy.navigatedFromNotification,
    selectedClaim:
      state.claimsReducer.selectedPolicy &&
      state.claimsReducer.selectedPolicy.selectedClaim,
    selectedInvoice:
      state.claimsReducer.selectedPolicy &&
      state.claimsReducer.selectedPolicy.selectedInvoice,
    providerInformationAvailable:
      state.claimsReducer.selectedPolicy &&
      state.claimsReducer.selectedPolicy.selectedInvoice &&
      !!state.claimsReducer.selectedPolicy.selectedInvoice.TreatingProviderName,
    treatingProviderName:
      state.claimsReducer.selectedPolicy &&
      state.claimsReducer.selectedPolicy.selectedInvoice &&
      state.claimsReducer.selectedPolicy.selectedInvoice.TreatingProviderName
        ? sentenceToTitleCase(
            state.claimsReducer.selectedPolicy.selectedInvoice
              .TreatingProviderName
          )
        : "the provider"
  };
};

export class PaymentDetails extends Component {
  static content = Store.PaymentDetails;
  componentDidUpdate() {
    if (!this.props.selectedInvoice) {
      this.props.history.push(Paths.Claims);
    }
  }

  topSectionContent = () => {
    const {
      PaymentDetails,
      IsPaymentNeededByMember
    } = this.props.selectedInvoice;

    let paymentTypeDecision = 0;

    if (PaymentDetails.Payee.IsPayeeTheMember) {
      paymentTypeDecision += 4;
    }
    if (IsPaymentNeededByMember) {
      paymentTypeDecision += 2;
    }
    if (PaymentDetails.HasAxaContributedToPaymentOfTreatments) {
      paymentTypeDecision += 1;
    }

    if (paymentTypeDecision === 2) {
      return this.props.content.topSectionBodyWithShortfallForProvider(
        this.props
      );
    } else if (paymentTypeDecision === 3) {
      return this.props.content.topSectionBodyWithShortfallForProviderWithReimbursement(
        this.props
      );
    } else if (paymentTypeDecision === 4 || paymentTypeDecision === 5) {
      return this.props.content.topSectionBodyWithoutShortfallForMember(
        this.props
      );
    } else if (paymentTypeDecision === 6) {
      return this.props.content.topSectionBodyWithShortfallForMember(
        this.props
      );
    } else if (paymentTypeDecision === 7) {
      return this.props.content.topSectionBodyWithShortfallForMemberWithReimbursment(
        this.props
      );
    } else {
      return this.props.content.topSectionBodyWithoutShortfallForProvider(
        this.props
      );
    }
  };

  renderSummaryDetailRows = () => (
    <SummaryDetail customClass="mt-2">
      <SummaryDetailRow
        title={this.props.content.summaryRowLabel1}
        value={formatCurrencyAmount(
          this.props.selectedInvoice.PaymentDetails.AmountClaimed
        )}
        customValueStyle={styles.iconSpacing}
      />
      <SummaryDetailRow
        title={this.props.content.summaryRowLabel2}
        value={formatCurrencyAmount(
          this.props.selectedInvoice.PaymentDetails.AmountPaid
        )}
        customValueStyle={styles.iconSpacing}
      />
      {this.props.isNotCashBenefitWithShortfall ? (
        <React.Fragment>
          <SummaryDetailRow
            title={this.props.content.summaryRowLabel3}
            value={formatCurrencyAmount(
              this.props.selectedInvoice.PaymentDetails
                .TotalMemberLiabilityAmount
            )}
            customValueStyle={
              styles.fontWeightSemibold 
            }
            tooltipIcon="icon-info-blue"
            tooltipContent={this.props.content.summaryRow3TooltipContent}
          />
          <SummaryDetailRow
            title={this.props.content.summaryRowLabel4}
            value={formatCurrencyAmount(
              this.props.selectedInvoice.PaymentDetails.AxaLiabilityAmount
            )}
            tooltipIcon="icon-info-blue"
            tooltipContent={this.props.content.summaryRow4TooltipContent}
          />
        </React.Fragment>
      ) : null}
    </SummaryDetail>
  );

  render() {
    const helpSet = this.props.content.HelpSet;
    let paymentDetailsHelpSet = [helpSet.ContactProvider];
    if (
      this.props.selectedInvoice &&
      this.props.selectedInvoice.PaymentDetails.Payee.IsPayeeTheMember
    ) {
      paymentDetailsHelpSet.unshift(helpSet.PaymentCheque);
      paymentDetailsHelpSet.push(helpSet.HowLongPayment);
    } else if (
      this.props.selectedInvoice &&
      this.props.selectedInvoice.IsPaymentNeededByMember
    ) {
      paymentDetailsHelpSet.push(helpSet.HowLongPayment);
    }
    const isThereAnyExcessLimit =
      this.props.selectedInvoice &&
      this.props.selectedInvoice.PaymentDetails.ExcessDetails.Limit > 0;

    return (
      <div className={styles.paymentDetails}>
        <div className="container">
          <div id="back-button" className="back-button">
            <Link
              to={
                this.props.navigatedFromNotification
                  ? Paths.Notifications
                  : Paths.ClaimDetails
              }
            >
              <span className="mr-2 left-arrow-back">←</span>{" "}
              {this.props.navigatedFromNotification
                ? this.props.content.backButtonLabelForNotification
                : this.props.content.backButtonLabel}
            </Link>
          </div>
        </div>
        {this.props.selectedInvoice ? (
          <ShadowedContainer>
            <div className="row">
              <div id="topSection" className={"col-lg-7 " + styles.topSection}>
                <Article
                  header={this.props.content.topSectionHeader}
                  body={this.topSectionContent()}
                />
                <div className={styles.topSectionBorderBottom} />
              </div>
              <div className="col-lg-4 offset-lg-1">
                <div className={styles.paymentSummary}>
                  <i className="icon-functional-calculator" />{" "}
                  <span className={styles.paymentSummaryTitle}>
                    {this.props.content.summaryTableHeader}
                  </span>
                  {this.renderSummaryDetailRows()}
                </div>
              </div>
            </div>
            {this.props.selectedInvoice.IsPaymentNeededByMember &&
            this.props.isNotCashBenefitWithShortfall &&
            this.props.providerInformationAvailable ? (
              <div
                id="whatIfIHavePaid"
                className={styles.isPaymentNeededByMember}
              >
                <Article
                  header={this.props.content.whatIfIhavePaidAlreadyTitle}
                  body={this.props.content.whatIfIhavePaidAlreadyBody}
                />
              </div>
            ) : null}
            <div className={styles.shortfallSummarySection}>
              {this.props.isNotCashBenefitWithShortfall &&
              this.props.providerInformationAvailable ? (
                <DetailContainer>
                  <ShortfallSummary />
                  {this.props.selectedInvoice.IsPaymentNeededByMember ? (
                    <HowToPayShortfallSection />
                  ) : null}
                </DetailContainer>
              ) : null}
            </div>

            <div id="invoiceBreakdown">
              <Article
                header={this.props.content.paymentBreakdownHeader}
                body={this.props.content.paymentBreakdownText}
              />
              <InvoiceBreakdown />
            </div>

            {isThereAnyExcessLimit ? (
              <WhatYouHaveUsedSection
                className={styles.whatYouHaveUsedSection}
              />
            ) : null}
            <div
              id="benefitFooter"
              className={styles.anchorDecorationUnderline}
            >
              {this.props.content.benefitFooter}
            </div>
            <div className={styles.helpSection}>
              <HelpSection
                HeadingLinkTo={this.props.content.HelpSection.HeadingLinkTo}
                HeadingLinkText={this.props.content.HelpSection.HeadingLinkText}
                MoreHelpLinkTo={this.props.content.HelpSection.MoreHelpLinkTo}
                MoreHelpLinkText={
                  this.props.content.HelpSection.MoreHelpLinkText
                }
                HelpSet={paymentDetailsHelpSet}
              />
            </div>
          </ShadowedContainer>
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToPaymentDetails)(Contentify(PaymentDetails));
